import React, { useEffect, useState } from 'react';
import {
  ExportUserTransferLog,
  GetUserTransferLog,
} from '../../../../Services/userServices';
import { Spinner } from '../../../SpinnerComponent/Spinner';
import { Tables } from '../../../TablesComponent/Tables';
import { PaginationComponent } from '../../../PaginationComponent/PaginationComponent';
import { getDownloadableLink, showError } from '../../../../Helper';
import GetAppIcon from '@material-ui/icons/GetApp';
import { ButtonBase } from '@material-ui/core';

function UserTransferLogComponent({
  parentTranslationPath,
  appUserId,
  paramsId,
}) {
  const [userTransferData, setUserTransferData] = useState([]);
  const [filter, setFilter] = useState({
    pageIndex: 0,
    pageSize: parseInt(localStorage.getItem('Pagination')) || 25,
  });
  const [isLoading, setIsLoading] = useState(false);
  const getUserTransferLog = async () => {
    setIsLoading(true);
    const body = {
      appUserId,
      filter,
    };
    try {
      const res = await GetUserTransferLog(body);
      setUserTransferData(res);
    } catch (error) {
      showError('something-went-wrong');
    } finally {
      setIsLoading(false);
    }
  };

  const userTransferHeaders = [
    { id: 1, label: 'team-name', input: 'teamName' },
    { id: 2, label: 'reporting-manager', input: 'teamManager' },
    {
      id: 3,
      label: 'operation-type',
      input: 'requestType',
      component: (row) =>
        row.requestType.toLowerCase() === 'create'
          ? 'Added to Team'
          : 'Removed from Team',
    },
    { id: 4, label: 'transfer-date', input: 'createdOn', isDate: true },
    {
      id: 5,
      label: 'transfer-time',
      input: 'createdOn',
      isDate: true,
      dateFormat: ' hh:mm A',
    },
    { id: 6, label: 'updated-by', input: 'createdBy' },
  ];
  const exportClickedHandler = async () => {
    try {
      const res = await ExportUserTransferLog({
        appUserId,
        filter: {
          ...filter,
          pageSize: userTransferData?.totalCount,
        },
      });

      const link = document.createElement('a');
      link.setAttribute('download', res.fileName);
      link.href = getDownloadableLink(res.uuid || res.documentId);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Download error:', error);
      showError('something-went-wrong');
    }
  };

  useEffect(() => {
    getUserTransferLog();
  }, [filter]);
  return (
    <div className='p-relative w-100 m-2'>
      <Spinner isActive={isLoading} />
      <div className='export-button-container '>
        <ButtonBase
          className='export-btn'
          onClick={exportClickedHandler}
        >
          <GetAppIcon color='primary' />
          <span className='history-text'>{'export'}</span>
        </ButtonBase>
      </div>
      <Tables
        data={userTransferData.result || []}
        headerData={userTransferHeaders}
        defaultActions={[]}
        parentTranslationPath={parentTranslationPath}
        itemsPerPage={filter.pageSize}
        activePage={filter.pageIndex}
      />

      <div className='pagination-wrapper-for-agent-history-tab'>
        <PaginationComponent
          pageIndex={filter?.pageIndex || 0}
          pageSize={filter?.pageSize || 25}
          totalCount={userTransferData?.totalCount || 0}
          onPageIndexChanged={(pageIndex) =>
            setFilter((prev) => ({
              ...prev,
              pageIndex,
            }))
          }
          onPageSizeChanged={(pageSize) =>
            setFilter((prev) => ({
              ...prev,
              pageSize,
              pageIndex: 0,
            }))
          }
        />
      </div>
    </div>
  );
}

export default UserTransferLogComponent;
